export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7460.8172d2de.jpg";